import { z } from 'zod';
import { APP_KEYS } from '../rbac/primitives.js';
/**
 * The Audit & Compliance Log (spec §13.7) — the read side.
 *
 * The write side has existed since Phase 1 (ADR-0016, ADR-0017); this is the screen
 * over it. It is a view and nothing else: there is no update and no delete here or
 * anywhere, and retention means archival, never deletion (Rule 2).
 */
/** The most rows one page returns. A page is a screenful, not an export. */
export const AUDIT_LOG_PAGE_MAX = 200;
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Use a date in the form YYYY-MM-DD.');
export const auditLogQuerySchema = z
    .object({
    /** Inclusive, as calendar dates in UTC. */
    from: isoDate.optional(),
    to: isoDate.optional(),
    /**
     * One application's entries. `platform` means the entries that belong to no
     * application — sign-ins, sessions, role and access changes.
     */
    app: z.enum([...APP_KEYS, 'platform']).optional(),
    action: z.string().trim().min(1).max(60).optional(),
    actorUserId: z.string().uuid().optional(),
    entityType: z.string().trim().min(1).max(80).optional(),
    entityId: z.string().uuid().optional(),
    /** Matches the record label and the actor's name. */
    search: z.string().trim().min(1).max(200).optional(),
    /** Keyset cursor: the id of the last entry on the previous page. */
    before: z.string().uuid().optional(),
    limit: z.coerce.number().int().min(1).max(AUDIT_LOG_PAGE_MAX).optional(),
})
    .refine((value) => !value.from || !value.to || value.from <= value.to, {
    message: 'The start date must not be after the end date.',
    path: ['to'],
});
export const auditLogExportFormatSchema = z.enum(['csv', 'xlsx', 'pdf']);
//# sourceMappingURL=audit-log.js.map